import React from "react";
import T from "prop-types";

import RezervaceTable from "b2b/components/rezervace-table/RezervaceTable";

export default function createContentRenderer({ datumOd, datumDo, stav }) {
  function RezervaceTabsContentRenderer({ indexActive, data }) {
    return data ? (
      <RezervaceTable
        datumOd={datumOd}
        datumDo={datumDo}
        stav={stav}
        typZdroje={data.typZdroje}
      />
    ) : null;
  }

  RezervaceTabsContentRenderer.propTypes = {
    indexActive: T.number,
    data: T.object,
    datumOd: T.instanceOf(Date),
    datumDo: T.instanceOf(Date),
    stav: T.string
  };

  return React.memo(RezervaceTabsContentRenderer);
}
